import { SModalContas } from "./styles"

import wss from "../../../../services/constants.json"

const ModalContas = ({close, relatorio, relatorio_2}) => {

    const handleClick = (type) => {
        if(type === "atual") window.open(`${wss.WSSERVER}/${relatorio}` , "_blank");
        if(type === "anterior") window.open(`${wss.WSSERVER}/${relatorio_2}` , "_blank");
        close()
    }

    return (
        <SModalContas>
            <div className="layer" onClick={close}/>
            <div className="modal-wrapper">
                <div>
                    <h3 className="text-dark text-center">Selecione o Mês:</h3>
                </div>
                <div className="row d-flex">
                    <div className="col-6">
                        <button className="btn bg-dark text-white" onClick={() => handleClick("atual")}>Mês Atual</button>
                    </div>
                    <div className="col-6">
                        <button className="btn bg-dark text-white" onClick={() => handleClick("anterior")}>Mês Anterior</button>
                    </div>
                </div>
            </div>
        </SModalContas>        
    )
}


export default ModalContas